// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.products-list-container .listing-header {
  display: flex;
  justify-content: space-between;
  padding: 0.3125rem 0 1.5625rem 0;
}
.products-list-container .listing-header .title-div {
  font-weight: bold;
  line-height: 1.75rem;
  font-size: 1.75rem;
  color: var(--ion-color-primary-black);
  text-transform: capitalize;
}
.products-list-container .listing-header .search-and-filter {
  display: flex;
  justify-content: flex-end;
}
.products-list-container .listing-header .search-and-filter .filter-div {
  display: flex;
}
.products-list-container .listing-header .search-and-filter .filter-div .filter-icon {
  display: flex;
  align-items: center;
  padding: 0 0.5625rem;
  cursor: pointer;
}
.products-list-container .listing-header .search-and-filter .filter-div .close-icon {
  display: flex;
  align-items: center;
  padding: 0 0.3125rem;
  cursor: pointer;
  align-self: center;
}
.products-list-container .listing-header .search-and-filter .filter-div .close-icon img {
  width: 1.5rem;
}
.products-list-container .listing-header .search-and-filter .filter-div .filter-label {
  cursor: pointer;
  font-weight: bold;
  font-size: 0.875rem;
  line-height: 1.1875rem;
  display: flex;
  align-items: center;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--ion-color-primary);
  opacity: 1;
}
.products-list-container .listing-header .search-and-filter .filter-div .close-label {
  color: var(--ion-color-primary-black) !important;
}
.products-list-container .listing-table {
  padding: 0 0 1.25rem;
  overflow-x: auto;
}
.products-list-container .listing-table .table {
  width: 100%;
}
.products-list-container .listing-table .table .column-heading {
  font-weight: 400;
  font-size: 0.975rem;
  line-height: 1.125rem;
  font-weight: bold;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
  padding: 0.75rem 0.5625rem 0.75rem 0;
  cursor: pointer;
}
.products-list-container .listing-table .table .status-col {
  max-width: 130px;
  width: 130px;
  min-width: 130px;
}
.products-list-container .listing-table .table .ship-to-col {
  min-width: 100px;
  max-width: 244px;
}
.products-list-container .listing-table .table .product-id {
  font-weight: bold;
  line-height: 1.5rem;
  font-size: 1rem;
  color: var(--ion-color-primary-black);
  opacity: 1;
  margin-left: 0.375rem;
}
.products-list-container .listing-table .table .table-body {
  font-weight: normal;
  line-height: 1.3125rem;
  font-size: 1rem;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}
.products-list-container .listing-table .table .table-body .table-row {
  border-bottom: 1px solid var(--ion-color-primary-border);
}
.products-list-container .listing-table .table .table-body .table-row td {
  padding: 0.4375rem 0.5625rem 0.1875rem 0;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.375rem;
  color: var(--ion-color-primary-black);
}
.products-list-container .listing-table .table .table-body .table-row .right-arrow {
  display: flex;
  align-items: center;
}
.products-list-container .mobile-view-listing .order-container .order-card {
  background: var(--ion-color-primary-white);
  border: 1px solid var(--ion-color-primary-border);
  border-radius: 2px;
  margin: 0.625rem 0;
}
.products-list-container .mobile-view-listing .order-container .order-card .order-card-col {
  padding-top: 0.9375rem;
}
.products-list-container .mobile-view-listing .order-container .order-card .grid-label {
  font-weight: 400;
  font-size: 0.6875rem;
  line-height: 0.8125rem;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
}
.products-list-container .mobile-view-listing .order-container .order-card .grid-values {
  padding-top: 0.1875rem;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.1875rem;
  color: var(--ion-color-secondary-blue);
}
.products-list-container .mobile-view-listing .order-container .mobile-right-arrow {
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-btn,
.pending,
.shipped,
.canceled {
  font-weight: 400;
  font-size: 0.8375rem;
  line-height: 1.125rem;
  border-radius: 4px;
  width: 100px;
  height: 2.125rem;
  text-transform: unset;
}

.pending {
  background: rgba(109, 207, 246, 0.2);
  color: var(--ion-color-primary-blue);
}

.shipped {
  background: rgba(172, 219, 97, 0.25);
  color: var(--ion-color-green-100);
}

.canceled {
  background: rgba(233, 75, 75, 0.1);
  color: var(--ion-color-primary);
}

.shipping,
.partially-shipped {
  background: rgba(255, 121, 23, 0.17);
  color: var(--ion-color-primary-orange);
}

.order-card .status-btn {
  width: auto;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 0.875rem;
}

.justify-end {
  justify-content: flex-end;
}

.justify-start {
  justify-content: flex-start;
}

.mass-upload-btn {
  width: 171px;
  height: 46px;
  background: var(--ion-color-primary) 0% 0% no-repeat padding-box;
  opacity: 1;
  font-weight: bold;
  line-height: 1.25rem;
  font-size: 0.937rem;
  letter-spacing: 0;
  color: var(--ion-color-primary-white);
  text-transform: uppercase;
  opacity: 1;
}

.products-number-div {
  font-weight: bold;
  line-height: 1.6875rem;
  font-size: 0.875rem;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}

.sr-no-col {
  min-width: 50px;
}

.id-col {
  min-width: 80px;
}

.img-col {
  min-width: 110px;
}

.name-col {
  min-width: 135px;
}

.customer-col {
  min-width: 100px;
}

.email-col {
  min-width: 140px;
}

.bill-to-col {
  min-width: 150px;
}

.ship-to-col {
  min-width: 300px;
}

.date-col {
  min-width: 130px;
}

.reason-of-cancel-col {
  min-width: 130px;
}

.qty-col {
  min-width: 70px;
}

.order-total-col {
  min-width: 80px;
}

.amount-refunded-col {
  min-width: 100px;
}

.view-col,
.delete-col {
  min-width: 2.5rem;
}

.edit-img-icon {
  cursor: pointer;
}

.search-icon.RTL {
  align-self: center;
  margin: 0.25rem 0 0 2.625rem;
  cursor: pointer;
}

.search-icon.LTR {
  align-self: center;
  margin: 0.25rem 2.625rem 0 0;
  cursor: pointer;
}

.product-checkbox {
  --opacity: 1;
  --border-color: var(--ion-color-primary-border);
  --border-width: 1px;
}

.thead {
  border-bottom: 1px solid var(--ion-color-primary-border);
  font-weight: 500;
  line-height: 0.875rem;
  font-size: 0.72rem;
  color: var(--ion-color-secondary-black);
  text-transform: uppercase;
  opacity: 1;
}

.pagination-wrapper {
  max-width: 1400px;
  margin: auto;
  text-align: center;
}

.pagination-div {
  align-items: center;
}

.pagination-grid {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin: 1.25rem 0;
}
.pagination-grid-tile {
  width: 33%;
  padding: 0;
}

.perpage-dropdown {
  display: flex;
  align-items: center;
}
.perpage-dropdown ion-item {
  font-weight: bold;
  line-height: 1.3125rem;
  font-size: 0.875rem;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}

.perpage-title {
  font-weight: normal;
  line-height: 1.3125rem;
  font-size: 0.875rem;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}

ion-select.LTR::part(icon) {
  opacity: 1;
  color: transparent;
  margin-left: 1rem;
  background: url('down-arrow-dark.1fb8e5fc34077de6.svg') no-repeat center;
}

ion-select.RTL::part(icon) {
  opacity: 1;
  color: transparent;
  margin-right: 1rem;
  background: url('down-arrow-dark.1fb8e5fc34077de6.svg') no-repeat center;
}

.pagination-col {
  text-align: left;
}

.search-div {
  margin-right: 1.25rem;
  align-self: center;
}
.search-div input {
  border: 1px solid var(--ion-color-primary-border);
  font-size: 0.75rem;
  padding: 0.1875rem 0.625rem;
  border-radius: 0;
}

.filter-apply-button {
  background: var(--ion-color-primary) 0% 0% no-repeat padding-box;
  opacity: 1;
  font-weight: bold;
  line-height: 1.1875rem;
  font-size: 0.875rem;
  letter-spacing: 0;
  color: var(--ion-color-primary-white);
  text-transform: uppercase;
  width: 92px;
  height: 38px;
}

.from-date-div,
.to-date-div {
  display: flex;
  align-items: center;
}

.from-date-label.RTL,
.to-date-label.RTL {
  margin-left: 0.625rem;
}

.from-date-label.LTR,
.to-date-label.LTR {
  margin-right: 0.625rem;
}

.from-date-class.RTL,
.to-date-class.RTL {
  margin-left: 1.25rem;
}

.from-date-class.LTR,
.to-date-class.LTR {
  margin-right: 1.25rem;
}

.apply-button {
  align-self: center;
}

.status-label {
  width: 100%;
  padding-bottom: 0.625rem;
  font-weight: bold;
  text-transform: capitalize !important;
  color: var(--ion-color-primary-black);
}

.filter-buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  column-gap: 0.625rem;
  row-gap: 0.625rem;
}

.filter-section {
  flex-wrap: wrap;
  justify-content: unset !important;
  column-gap: 1.25rem;
}

.from-date-div,
.to-date-div {
  width: unset;
  margin-bottom: 0.9375rem;
}

.from-date-class,
.to-date-class {
  max-width: 190px;
}

.to-date-class {
  margin-top: 2rem;
}

.status-container {
  column-gap: 20px;
}

@media (max-width: 767px) {
  .product-search-div ion-item {
    width: 100%;
  }
  .from-date-class,
  .to-date-class,
  .status-select-input {
    max-width: 100%;
    width: 100%;
  }
  .products-list-container .listing-header {
    display: block;
  }
  .products-list-container .listing-header .title-div {
    font-size: 1.625rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/return-orders-management/return-orders-management.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAGC;EACC,aAAA;EACA,8BAAA;EACA,gCAAA;AAFF;AAIE;EACC,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,qCAAA;EACA,0BAAA;AAFH;AAKE;EACC,aAAA;EACA,yBAAA;AAHH;AAKG;EACC,aAAA;AAHJ;AAKI;EACC,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;AAHL;AAMI;EACC,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;AAJL;AAMK;EACC,aAAA;AAJN;AAQI;EACC,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,+BAAA;EACA,UAAA;AANL;AASI;EACC,gDAAA;AAPL;AAaC;EACC,oBAAA;EACA,gBAAA;AAXF;AAaE;EACC,WAAA;AAXH;AAaG;EACC,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,uCAAA;EACA,oCAAA;EACA,eAAA;AAXJ;AAcG;EACC,gBAAA;EACA,YAAA;EACA,gBAAA;AAZJ;AAeG;EACC,gBAAA;EACA,gBAAA;AAbJ;AAgBG;EACC,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,qCAAA;EACA,UAAA;EACA,qBAAA;AAdJ;AAiBG;EACC,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AAfJ;AAiBI;EACC,wDAAA;AAfL;AAiBK;EACC,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,qCAAA;AAfN;AAkBK;EACC,aAAA;EACA,mBAAA;AAhBN;AA0BG;EACC,0CAAA;EACA,iDAAA;EACA,kBAAA;EACA,kBAAA;AAxBJ;AA0BI;EACC,sBAAA;AAxBL;AA2BI;EACC,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,uCAAA;AAzBL;AA4BI;EACC,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,sCAAA;AA1BL;AA8BG;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AA5BJ;;AAmCA;;;;EAIC,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AAhCD;;AAmCA;EACC,oCAAA;EACA,oCAAA;AAhCD;;AAmCA;EACC,oCAAA;EACA,iCAAA;AAhCD;;AAmCA;EACC,kCAAA;EACA,+BAAA;AAhCD;;AAmCA;;EAEC,oCAAA;EACA,sCAAA;AAhCD;;AAoCC;EACC,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AAjCF;;AAqCA;EACC,yBAAA;AAlCD;;AAqCA;EACC,2BAAA;AAlCD;;AAqCA;EACC,YAAA;EACA,YAAA;EACA,gEAAA;EACA,UAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,yBAAA;EACA,UAAA;AAlCD;;AAqCA;EACC,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AAlCD;;AAqCA;EACC,eAAA;AAlCD;;AAqCA;EACC,eAAA;AAlCD;;AAqCA;EACC,gBAAA;AAlCD;;AAqCA;EACC,gBAAA;AAlCD;;AAqCA;EACC,gBAAA;AAlCD;;AAqCA;EACC,gBAAA;AAlCD;;AAqCA;EACC,gBAAA;AAlCD;;AAqCA;EACC,gBAAA;AAlCD;;AAqCA;EACC,gBAAA;AAlCD;;AAqCA;EACC,gBAAA;AAlCD;;AAqCA;EACC,eAAA;AAlCD;;AAqCA;EACC,eAAA;AAlCD;;AAqCA;EACC,gBAAA;AAlCD;;AAqCA;;EAEC,iBAAA;AAlCD;;AAqCA;EACC,eAAA;AAlCD;;AAqCA;EACC,kBAAA;EACA,4BAAA;EACA,eAAA;AAlCD;;AAqCA;EACC,kBAAA;EACA,4BAAA;EACA,eAAA;AAlCD;;AAqCA;EACC,YAAA;EACA,+CAAA;EACA,mBAAA;AAlCD;;AAqCA;EACC,wDAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,uCAAA;EACA,yBAAA;EACA,UAAA;AAlCD;;AAqCA;EACC,iBAAA;EACA,YAAA;EACA,kBAAA;AAlCD;;AAqCA;EACC,mBAAA;AAlCD;;AAqCA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AAlCD;AAoCC;EACC,UAAA;EACA,UAAA;AAlCF;;AAsCA;EACC,aAAA;EACA,mBAAA;AAnCD;AAqCC;EACC,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AAnCF;;AAuCA;EACC,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AApCD;;AAuCA;EACC,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,wEAAA;AApCD;;AAuCA;EACC,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,wEAAA;AApCD;;AAuCA;EACC,gBAAA;AApCD;;AAuCA;EACC,qBAAA;EACA,kBAAA;AApCD;AAsCC;EACC,iDAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;AApCF;;AAyCA;EACC,gEAAA;EACA,UAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;AAtCD;;AAyCA;;EAEC,aAAA;EACA,mBAAA;AAtCD;;AAyCA;;EAEC,qBAAA;AAtCD;;AAyCA;;EAEC,sBAAA;AAtCD;;AAyCA;;EAEC,oBAAA;AAtCD;;AAyCA;;EAEC,qBAAA;AAtCD;;AAyCA;EACC,kBAAA;AAtCD;;AAyCA;EACC,WAAA;EACA,wBAAA;EACA,iBAAA;EACA,qCAAA;EACA,qCAAA;AAtCD;;AAyCA;EACC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,oBAAA;EACA,iBAAA;AAtCD;;AAyCA;EACC,eAAA;EACA,iCAAA;EACA,mBAAA;AAtCD;;AAyCA;;EAEC,YAAA;EACA,wBAAA;AAtCD;;AAyCA;;EAEC,gBAAA;AAtCD;;AAyCA;EACC,gBAAA;AAtCD;;AAyCA;EACC,gBAAA;AAtCD;;ACrTQ;ED+VP;IACC,WAAA;EAtCA;EAyCD;;;IAGC,eAAA;IACA,WAAA;EAvCA;EA0CD;IACC,cAAA;EAxCA;EA0CA;IACC,mBAAA;EAxCD;AACF","sourcesContent":["@import \"src/theme/mixins.scss\";\n\n.products-list-container {\n\t.listing-header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding: 0.3125rem 0 1.5625rem 0;\n\n\t\t.title-div {\n\t\t\tfont-weight: bold;\n\t\t\tline-height: 1.75rem;\n\t\t\tfont-size: 1.75rem;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\ttext-transform: capitalize\n\t\t}\n\n\t\t.search-and-filter {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: flex-end;\n\n\t\t\t.filter-div {\n\t\t\t\tdisplay: flex;\n\n\t\t\t\t.filter-icon {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tpadding: 0 0.5625rem;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t}\n\n\t\t\t\t.close-icon {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tpadding: 0 0.3125rem;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\talign-self: center;\n\n\t\t\t\t\timg {\n\t\t\t\t\t\twidth: 1.5rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.filter-label {\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\tline-height: 1.1875rem;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tletter-spacing: 0.4px;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\n\t\t\t\t.close-label {\n\t\t\t\t\tcolor: var(--ion-color-primary-black) !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.listing-table {\n\t\tpadding: 0 0 1.25rem;\n\t\toverflow-x: auto;\n\n\t\t.table {\n\t\t\twidth: 100%;\n\n\t\t\t.column-heading {\n\t\t\t\tfont-weight: 400;\n\t\t\t\tfont-size: 0.975rem;\n\t\t\t\tline-height: 1.125rem;\n\t\t\t\tfont-weight: bold;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tcolor: var(--ion-color-secondary-black);\n\t\t\t\tpadding: 0.75rem 0.5625rem 0.75rem 0;\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\t.status-col {\n\t\t\t\tmax-width: 130px;\n\t\t\t\twidth: 130px;\n\t\t\t\tmin-width: 130px;\n\t\t\t}\n\n\t\t\t.ship-to-col {\n\t\t\t\tmin-width: 100px;\n\t\t\t\tmax-width: 244px;\n\t\t\t}\n\n\t\t\t.product-id {\n\t\t\t\tfont-weight: bold;\n\t\t\t\tline-height: 1.5rem;\n\t\t\t\tfont-size: 1rem;\n\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\topacity: 1;\n\t\t\t\tmargin-left: 0.375rem;\n\t\t\t}\n\n\t\t\t.table-body {\n\t\t\t\tfont-weight: normal;\n\t\t\t\tline-height: 1.3125rem;\n\t\t\t\tfont-size: 1rem;\n\t\t\t\tletter-spacing: 0;\n\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\topacity: 1;\n\n\t\t\t\t.table-row {\n\t\t\t\t\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\n\t\t\t\t\ttd {\n\t\t\t\t\t\tpadding: 0.4375rem 0.5625rem 0.1875rem 0;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t\tline-height: 1.375rem;\n\t\t\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\t\t}\n\n\t\t\t\t\t.right-arrow {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t}\n\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.mobile-view-listing {\n\t\t.order-container {\n\t\t\t.order-card {\n\t\t\t\tbackground: var(--ion-color-primary-white);\n\t\t\t\tborder: 1px solid var(--ion-color-primary-border);\n\t\t\t\tborder-radius: 2px;\n\t\t\t\tmargin: 0.625rem 0;\n\n\t\t\t\t.order-card-col {\n\t\t\t\t\tpadding-top: 0.9375rem;\n\t\t\t\t}\n\n\t\t\t\t.grid-label {\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tfont-size: 0.6875rem;\n\t\t\t\t\tline-height: 0.8125rem;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tcolor: var(--ion-color-secondary-black);\n\t\t\t\t}\n\n\t\t\t\t.grid-values {\n\t\t\t\t\tpadding-top: 0.1875rem;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\tline-height: 1.1875rem;\n\t\t\t\t\tcolor: var(--ion-color-secondary-blue);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.mobile-right-arrow {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t}\n\t}\n\n}\n\n.status-btn,\n.pending,\n.shipped,\n.canceled {\n\tfont-weight: 400;\n\tfont-size: 0.8375rem;\n\tline-height: 1.125rem;\n\tborder-radius: 4px;\n\twidth: 100px;\n\theight: 2.125rem;\n\ttext-transform: unset;\n}\n\n.pending {\n\tbackground: rgba(109, 207, 246, 0.2);\n\tcolor: var(--ion-color-primary-blue);\n}\n\n.shipped {\n\tbackground: rgba(172, 219, 97, 0.25);\n\tcolor: var(--ion-color-green-100);\n}\n\n.canceled {\n\tbackground: rgba(233, 75, 75, 0.1);\n\tcolor: var(--ion-color-primary);\n}\n\n.shipping,\n.partially-shipped {\n\tbackground: rgba(255, 121, 23, 0.17);\n\tcolor: var(--ion-color-primary-orange);\n}\n\n.order-card {\n\t.status-btn {\n\t\twidth: auto;\n\t\tfont-weight: 500;\n\t\tfont-size: 0.875rem;\n\t\tline-height: 0.875rem;\n\t}\n}\n\n.justify-end {\n\tjustify-content: flex-end;\n}\n\n.justify-start {\n\tjustify-content: flex-start;\n}\n\n.mass-upload-btn {\n\twidth: 171px;\n\theight: 46px;\n\tbackground: var(--ion-color-primary) 0% 0% no-repeat padding-box;\n\topacity: 1;\n\tfont-weight: bold;\n\tline-height: 1.25rem;\n\tfont-size: 0.937rem;\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-primary-white);\n\ttext-transform: uppercase;\n\topacity: 1;\n}\n\n.products-number-div {\n\tfont-weight: bold;\n\tline-height: 1.6875rem;\n\tfont-size: 0.875rem;\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-primary-black);\n\topacity: 1;\n}\n\n.sr-no-col {\n\tmin-width: 50px;\n}\n\n.id-col {\n\tmin-width: 80px;\n}\n\n.img-col {\n\tmin-width: 110px;\n}\n\n.name-col {\n\tmin-width: 135px;\n}\n\n.customer-col {\n\tmin-width: 100px;\n}\n\n.email-col {\n\tmin-width: 140px;\n}\n\n.bill-to-col {\n\tmin-width: 150px;\n}\n\n.ship-to-col {\n\tmin-width: 300px;\n}\n\n.date-col {\n\tmin-width: 130px;\n}\n\n.reason-of-cancel-col {\n\tmin-width: 130px;\n}\n\n.qty-col {\n\tmin-width: 70px;\n}\n\n.order-total-col {\n\tmin-width: 80px;\n}\n\n.amount-refunded-col {\n\tmin-width: 100px;\n}\n\n.view-col,\n.delete-col {\n\tmin-width: 2.5rem;\n}\n\n.edit-img-icon {\n\tcursor: pointer;\n}\n\n.search-icon.RTL {\n\talign-self: center;\n\tmargin: 0.25rem 0 0 2.625rem;\n\tcursor: pointer;\n}\n\n.search-icon.LTR {\n\talign-self: center;\n\tmargin: 0.25rem 2.625rem 0 0;\n\tcursor: pointer;\n}\n\n.product-checkbox {\n\t--opacity: 1;\n\t--border-color: var(--ion-color-primary-border);\n\t--border-width: 1px;\n}\n\n.thead {\n\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\tfont-weight: 500;\n\tline-height: 0.875rem;\n\tfont-size: 0.72rem;\n\tcolor: var(--ion-color-secondary-black);\n\ttext-transform: uppercase;\n\topacity: 1;\n}\n\n.pagination-wrapper {\n\tmax-width: 1400px;\n\tmargin: auto;\n\ttext-align: center;\n}\n\n.pagination-div {\n\talign-items: center;\n}\n\n.pagination-grid {\n\tdisplay: flex;\n\tflex-flow: row wrap;\n\tjustify-content: space-between;\n\tmargin: 1.25rem 0;\n\n\t&-tile {\n\t\twidth: 33%;\n\t\tpadding: 0;\n\t}\n}\n\n.perpage-dropdown {\n\tdisplay: flex;\n\talign-items: center;\n\n\tion-item {\n\t\tfont-weight: bold;\n\t\tline-height: 1.3125rem;\n\t\tfont-size: 0.875rem;\n\t\tletter-spacing: 0;\n\t\tcolor: var(--ion-color-primary-black);\n\t\topacity: 1;\n\t}\n}\n\n.perpage-title {\n\tfont-weight: normal;\n\tline-height: 1.3125rem;\n\tfont-size: 0.875rem;\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-primary-black);\n\topacity: 1;\n}\n\nion-select.LTR::part(icon) {\n\topacity: 1;\n\tcolor: transparent;\n\tmargin-left: 1rem;\n\tbackground: url('../../../assets/icon/down-arrow-dark.svg') no-repeat center;\n}\n\nion-select.RTL::part(icon) {\n\topacity: 1;\n\tcolor: transparent;\n\tmargin-right: 1rem;\n\tbackground: url('../../../assets/icon/down-arrow-dark.svg') no-repeat center;\n}\n\n.pagination-col {\n\ttext-align: left;\n}\n\n.search-div {\n\tmargin-right: 1.25rem;\n\talign-self: center;\n\n\tinput {\n\t\tborder: 1px solid var(--ion-color-primary-border);\n\t\tfont-size: 0.75rem;\n\t\tpadding: 0.1875rem 0.625rem;\n\t\tborder-radius: 0;\n\t}\n}\n\n\n.filter-apply-button {\n\tbackground: var(--ion-color-primary) 0% 0% no-repeat padding-box;\n\topacity: 1;\n\tfont-weight: bold;\n\tline-height: 1.1875rem;\n\tfont-size: 0.875rem;\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-primary-white);\n\ttext-transform: uppercase;\n\twidth: 92px;\n\theight: 38px;\n}\n\n.from-date-div,\n.to-date-div {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.from-date-label.RTL,\n.to-date-label.RTL {\n\tmargin-left: 0.625rem;\n}\n\n.from-date-label.LTR,\n.to-date-label.LTR {\n\tmargin-right: 0.625rem;\n}\n\n.from-date-class.RTL,\n.to-date-class.RTL {\n\tmargin-left: 1.25rem;\n}\n\n.from-date-class.LTR,\n.to-date-class.LTR {\n\tmargin-right: 1.25rem;\n}\n\n.apply-button {\n\talign-self: center;\n}\n\n.status-label {\n\twidth: 100%;\n\tpadding-bottom: 0.625rem;\n\tfont-weight: bold;\n\ttext-transform: capitalize !important;\n\tcolor: var(--ion-color-primary-black);\n}\n\n.filter-buttons {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tcolumn-gap: 0.625rem;\n\trow-gap: 0.625rem;\n}\n\n.filter-section {\n\tflex-wrap: wrap;\n\tjustify-content: unset !important;\n\tcolumn-gap: 1.25rem;\n}\n\n.from-date-div,\n.to-date-div {\n\twidth: unset;\n\tmargin-bottom: 0.9375rem;\n}\n\n.from-date-class,\n.to-date-class {\n\tmax-width: 190px;\n}\n\n.to-date-class {\n\tmargin-top: 2rem;\n}\n\n.status-container {\n\tcolumn-gap: 20px;\n}\n\n@include respond-below(md) {\n\t.product-search-div ion-item {\n\t\twidth: 100%;\n\t}\n\n\t.from-date-class,\n\t.to-date-class,\n\t.status-select-input {\n\t\tmax-width: 100%;\n\t\twidth: 100%;\n\t}\n\n\t.products-list-container .listing-header {\n\t\tdisplay: block;\n\n\t\t.title-div {\n\t\t\tfont-size: 1.625rem;\n\t\t}\n\t}\n}","// custom fons facemizxin\n\n@mixin font-face($font-family, $url) {\n    @font-face {\n        font-family: '#{$font-family}';\n        src: url('#{$url}.eot');\n        src: url('#{$url}.eot?#iefix') format('embedded-opentype'),\n        url('#{$url}.woff') format('woff'),\n        url('#{$url}.ttf') format('truetype'),\n        url('#{$url}.svg') format('svg');\n        font-weight: normal;\n        font-style: normal;\n    }\n}\n\n\n\n//custom font resposnive muin\n$font-base-min: 14px;\n$font-base-max: 6;\n$breakmin: 320px;\n$breakmax: 768px;\n$customSize: 5px;\n\n@mixin font-responsive($fmin, $fdiff, $breakmin, $breakdiff) {\n    font-size: calc(#{$fmin} + #{$fdiff} * ((100vw - #{$breakmin}) / #{$breakdiff}));\n\n    @media(max-width: $breakmin) {\n        font-size: $fmin;\n    }\n\n    @media(min-width: round($breakmin + $breakmax)) {\n        font-size: round($fmin + $fdiff);\n    }\n\n    @media(max-width: $breakmax) {\n        // font-size: round($fmin + 3px);\n        font-size: calc(#{$fmin} + #{$customSize});\n    }\n}\n\n\n// custom font source mmixins\n\n@mixin font($colour: false, $weight: false, $lh: false, $spacing: false) {\n\n    // @if $size { font-size: $size; }\n    @if $colour {\n        color: $colour;\n    }\n\n    @if $weight {\n        font-weight: $weight;\n    }\n\n    @if $lh {\n        line-height: $lh;\n    }\n\n    @if $spacing {\n        letter-spacing: $spacing;\n    }\n}\n\n\n// custom input placeholder mixins\n\n@mixin input-placeholder {\n    &.placeholder {\n        @content;\n    }\n\n    &:-moz-placeholder {\n        @content;\n    }\n\n    &::-moz-placeholder {\n        @content;\n    }\n\n    &:-ms-input-placeholder {\n        @content;\n    }\n\n    &::-webkit-input-placeholder {\n        @content;\n    }\n}\n\n\n// A map of breakpoints.\n$breakpoints: (\n    xs: 480px,\n    sm: 576px,\n    md: 768px,\n    lg: 992px,\n    xl: 1200px,\n    xxl: 1600px,\n    ipadSize: 768px,\n    ipadmin:481px,\n    ipadmax:1024px,\n    ipadlandscape:1320px,\n\n);\n\n// Respond above.\n@mixin respond-above($breakpoint) {\n\n    // If the breakpoint exists in the map.\n    @if map-has-key($breakpoints, $breakpoint) {\n\n        // Get the breakpoint value.\n        $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n        // Write the media query.\n        @media (min-width: $breakpoint-value) {\n            @content;\n        }\n\n        // If the breakpoint doesn't exist in the map.\n    }\n\n    @else {\n\n        // Log a warning.\n        @warn 'Invalid breakpoint: #{$breakpoint}.';\n    }\n}\n\n\n\n\n@mixin respond-below($breakpoint) {\n\n    // If the breakpoint exists in the map.\n    @if map-has-key($breakpoints, $breakpoint) {\n\n        // Get the breakpoint value.\n        $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n        // Write the media query.\n        @media (max-width: ($breakpoint-value - 1)) {\n            @content;\n        }\n\n        // If the breakpoint doesn't exist in the map.\n    }\n\n    @else {\n\n        // Log a warning.\n        @warn 'Invalid breakpoint: #{$breakpoint}.';\n    }\n}\n\n\n\n@mixin respond-between($lower, $upper) {\n\n    // If both the lower and upper breakpoints exist in the map.\n    @if map-has-key($breakpoints, $lower) and map-has-key($breakpoints, $upper) {\n\n        // Get the lower and upper breakpoints.\n        $lower-breakpoint: map-get($breakpoints, $lower);\n        $upper-breakpoint: map-get($breakpoints, $upper);\n\n        // Write the media query.\n        @media (min-width: $lower-breakpoint) and (max-width: ($upper-breakpoint - 1)) {\n            @content;\n        }\n\n        // If one or both of the breakpoints don't exist.\n    }\n\n    @else {\n\n        // If lower breakpoint is invalid.\n        @if (map-has-key($breakpoints, $lower)==false) {\n\n            // Log a warning.\n            @warn 'Your lower breakpoint was invalid: #{$lower}.';\n        }\n\n        // If upper breakpoint is invalid.\n        @if (map-has-key($breakpoints, $upper)==false) {\n\n            // Log a warning.\n            @warn 'Your upper breakpoint was invalid: #{$upper}.';\n        }\n    }\n}\n\n\n// @media only screen and (device-width: 768px) {}\n\n// @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:portrait) {}\n\n// @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:landscape) {\n//     /* For landscape layouts only */\n// }\n\n/// vernodr prefixes\n\n@mixin css3-prefix($prop, $value) {\n    -webkit-#{$prop}: #{$value};\n    -moz-#{$prop}: #{$value};\n    -ms-#{$prop}: #{$value};\n    -o-#{$prop}: #{$value};\n    #{$prop}: #{$value};\n}\n\n\n//  vertical cneter\n@mixin vertical-center {\n    position: relative;\n    top: 50%;\n    -ms-transform: translateY(-50%);\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n}\n\n//keyframe miins\n\n@mixin keyframes($name) {\n    @-webkit-keyframes #{$name} {\n        @content;\n    }\n\n    @-moz-keyframes #{$name} {\n        @content;\n    }\n\n    @keyframes #{$name} {\n        @content;\n    }\n}\n\n//absolute positoning\n\n@mixin abs-position ($top, $right, $bottom, $left) {\n    position: absolute;\n    top: $top;\n    right: $right;\n    bottom: $bottom;\n    left: $left;\n}\n\n\n//arrow minis\n@mixin arrow($direction: down, $size: 5px, $color: #555) {\n    width: 0;\n    height: 0;\n\n    @if ($direction ==left) {\n        border-top: $size solid transparent;\n        border-bottom: $size solid transparent;\n        border-right: $size solid $color;\n    }\n\n    @else if ($direction ==right) {\n        border-top: $size solid transparent;\n        border-bottom: $size solid transparent;\n        border-left: $size solid $color;\n    }\n\n    @else if ($direction ==down) {\n        border-left: $size solid transparent;\n        border-right: $size solid transparent;\n        border-top: $size solid $color;\n    }\n\n    @else {\n        border-left: $size solid transparent;\n        border-right: $size solid transparent;\n        border-bottom: $size solid $color;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
